import React from "react"
import { routePaths } from "../.."
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"
import { AppWorkerGroupList } from "../../../Components/Views/Dashboard/Sections/AppDetail/Worker/AppWorkerGroupList"
import { defaultAppWorkerGroupSort } from "../../../Components/Views/Dashboard/Sections/AppDetail/Worker/Common/constants"
import { useDecodeFilterAndSort } from "../../../Hooks/useDecodeFilterAndSort"
import { AppDetailRouteComponentProps } from "../../RouteProps"

export function AppWorkerGroupListRoute({
    match,
    location
}: AppDetailRouteComponentProps<{}>) {
    const { sort } = useDecodeFilterAndSort(
        location.search,
        defaultAppWorkerGroupSort,
        routePaths.appWorkerGroupList(
            match.params.orgUsername,
            match.params.appID
        )
    )

    return (
        <AppAuthCheck {...match.params} scope="workers:view">
            <AppWorkerGroupList {...match.params} sort={sort} />
        </AppAuthCheck>
    )
}
